const EMPTY_LENGTH = 0;

/**
 * @desc Rich-text editors keep markup like `<p><br></p>` for an empty value, so a plain truthy check is not enough.
 * @param {string} html
 * @returns {boolean}
 */
export const hasRichTextContent = html =>
  String(html ?? '')
    .replaceAll(/<[^>]+>/g, '')
    .replaceAll('&nbsp;', ' ')
    .trim().length > EMPTY_LENGTH;
